/* eslint-disable tailwindcss/no-arbitrary-value */
import React, { useState } from 'react';
import {
  Button,
  Drawer,
  DrawerBody,
  DrawerFooter,
  DrawerHeader,
} from '@one-thd/sui-atomic-components';
import { useFitCompatibility } from '../FitCompatibilityProvider';
import { LAUNDRY_DRAWER_MAPPING } from '../../applianceConstants/laundry';
import { REFRIGERATOR_MAPPING } from '../../applianceConstants/refrigerator';
import { BuildDrawer } from './drawerComponents/index';


export const IconInfoDrawer = () => {
  const {
    drawerPosition,
    drawerInfoIcon,
    setDrawerInfoIcon,
    drawerIndex,
    setDrawerIndex,
    isRefrigerator
  } = useFitCompatibility();

  const [selectedTab, setSelectedTab] = useState(0);

  const onDrawerClose = () => {
    setDrawerInfoIcon(false);
    setDrawerIndex(0);
    setSelectedTab(0);
  };

  const {
    subHeader,
    sections,
  } = isRefrigerator ? REFRIGERATOR_MAPPING[drawerIndex] : LAUNDRY_DRAWER_MAPPING[drawerIndex];

  return (
    <Drawer
      DrawerRootProps={{
        id: 'fit-compatibility-drawer'
      }}
      position={drawerPosition}
      open={drawerInfoIcon}
      onClose={onDrawerClose}
    >
      <DrawerHeader
        title={subHeader}
        onClose={onDrawerClose}
      />
      <hr className="sui-h-1 sui-bg-gray-300 sui-border-0 sui-rounded sui-shadow-md" />

      <DrawerBody>
        <div className="sui-mt-2">
          {BuildDrawer(sections,0,selectedTab,setSelectedTab,true)}
        </div>
      </DrawerBody>
      <DrawerFooter>
        <Button
          fullWidth
          onClick={() => {
            onDrawerClose();
          }}
        >
          Close
        </Button>
      </DrawerFooter>
    </Drawer>
  );
};
